import JikeLogo from '@/assets/jike-logo.svg?react'
import { Button, Stack, Text, Title } from '@mantine/core'
import styles from './AbnormalEnvironmentPage.module.css'
import Page, { type PageProps } from './Page'

export interface AbnormalEnvironmentPageProps extends PageProps {}

export default function AbnormalEnvironmentPage({ ...props }: AbnormalEnvironmentPageProps) {
	const handleRetry = () => {
		window.location.href = '/login'
	}

	return (
		<Page {...props}>
			<Stack className={styles.container} align="center" justify="center" gap={0}>
				<JikeLogo className={styles.logo} />

				<Title order={1} className={styles.title}>
					运行环境异常
				</Title>

				<Text className={styles.description}>
					检测到您的浏览器环境异常，为保护数据安全与用户体验，请确认环境安全后重新登录。
				</Text>

				<Button size="md" variant="filled" onClick={handleRetry}>
					重新登录
				</Button>
			</Stack>
		</Page>
	)
}
